import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(dona)/lnd/confirm/page.jsx");
